export { default } from "bullitttime-embermodelsevent/models/timing-impulse";
